"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var handleAdyenErrorMessage = function handleAdyenErrorMessage(responseError) {
  var adyenComponent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var handleMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  handleMessage && responseError.message && handleMessage(responseError.message, false, false, "", true);
  if (adyenComponent) {
    adyenComponent.unmount();
    adyenComponent.mount(adyenComponent.elementRef.elementRef._node);
  }
  return responseError.message;
};
var _default = handleAdyenErrorMessage;
exports["default"] = _default;